import ClaudeAuth from './ClaudeAuth';
export default ClaudeAuth;
